import { required, requiredIf } from 'vuelidate/lib/validators';

const drivers = [
  'a significant reduction in turnover compared to the same period in 2018/19',
  'a temporary suspension or closure of the business',
  'much weaker trading conditions due to social distancing and the movement restrictions imposed on the broader population',
  'an inability to reliably source usual supplies due to the disruption caused by Covid-19',
  'a disruption to the tenant\'s business due to staff being unable to attend work due to social distancing and the movement restrictions imposed on the broader population',
  'other',
];

const mStep = {
  title: 'Rent Relief Drivers',
  description: 'Identify the factors impacting the tenant\'s business due to Covid-19 that warrant rent relief',
};

export default {
  name: 'rent-relief-drivers',
  data: () => ({
    drivers,
    mStep,
    closureDate: '',
  }),
  computed: {
    hasClosure() {
      return this.driversSelection.includes('a temporary suspension or closure of the business');
    },
    driversSelection: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.drivers.drivers;
      },
      set(value) {
        const newdrivers = { drivers: value };
        if (!value.includes('other')) {
          newdrivers.other = '';
        }
        if (!value.includes('a temporary suspension or closure of the business')) {
          newdrivers.closure = {
            hasClosure: undefined,
          };
        }
        this.$store.dispatch('toolkit/updateItemKey', { data: { adjustments: { drivers: newdrivers } } });
      },
    },
    other: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.drivers.other;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { adjustments: { drivers: { other: value } } } });
      },
    },
    closure: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.drivers.closure.hasClosure;
      },
      async set(value) {
        const closure = { hasClosure: value };
        if (value === 'no') {
          await this.resetClosureDate();
        }
        this.$store.dispatch('toolkit/updateItemKey', { data: { adjustments: { drivers: { closure } } } });
      },
    },
  },
  methods: {
    async resetClosureDate() {
      this.closureDate = null;
      await this.$nextTick();
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  watch: {
    closureDate(value) {
      this.$store.dispatch('toolkit/updateItemKey', { data: { adjustments: { drivers: { closure: { hasClosure: this.closure, date: value } } } } });
    },
  },
  mounted() {
    this.closureDate = new Date(this.$store.getters['toolkit/getItemData'].adjustments.drivers.closure.date);
  },
  validations: {
    driversSelection: {
      required,
    },
    closure: {
      required: requiredIf(function closureRequired() {
        if (this.hasClosure) {
          return true;
        }
        return false;
      }),
    },
    closureDate: {
      required: requiredIf(function closureDateRequired() {
        if (this.hasClosure && this.closure === 'yes') {
          return true;
        }
        return false;
      }),
    },
    other: {
      required: requiredIf(function otherRequired() {
        if (this.driversSelection.findIndex(value => value === 'other') >= 0) {
          return true;
        }
        return false;
      }),
    },
  },
};
